import { BasicButton, RadioCard, Typography } from "@/components";
import { type CaseReferralFormFieldSchema, MESSAGE_TAG } from "@/schemas";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { Link, createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

export const Route = createFileRoute("/dashboard/case/referrals/type")({
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = Route.useNavigate();
	const { watch, register } = useFormContext<CaseReferralFormFieldSchema>();
	const caseId = watch("caseId");
	const tags = watch("tags");
	const registerTags = register("tags");

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		if (!caseId) {
			navigate({
				replace: true,
				to: "/dashboard/case/referrals",
			});
		}
	}, [caseId]);

	return (
		<>
			<div className="container flex flex-col gap-1">
				<Typography fontWeight={900} fontSize={14}>
					Select one of the external type:
				</Typography>
				<Typography fontWeight={400} fontSize={12}>
					Choose the type of collaboration you need for this case:
				</Typography>
			</div>
			<div className="container flex-1 flex flex-col gap-3">
				<RadioCard
					{...registerTags}
					value={MESSAGE_TAG.REFERAL}
					checked={tags === MESSAGE_TAG.REFERAL}
					title="Referral"
					info="Refer the patient to another department"
					inputProps={{
						name: "tags",
						onChange: registerTags.onChange,
						onBlur: registerTags.onBlur,
					}}
				/>
				<RadioCard
					{...registerTags}
					value={MESSAGE_TAG.SPECIALISTS_ADVICE}
					checked={tags === MESSAGE_TAG.SPECIALISTS_ADVICE}
					title="Advice"
					info="Request consultation while retaining care"
					inputProps={{
						name: "tags",
						onChange: registerTags.onChange,
						onBlur: registerTags.onBlur,
					}}
				/>
				<RadioCard
					{...registerTags}
					value={MESSAGE_TAG.HANDOVER}
					checked={tags === MESSAGE_TAG.HANDOVER}
					title="Handover"
					info="Transfer care to another department"
					inputProps={{
						name: "tags",
						onChange: registerTags.onChange,
						onBlur: registerTags.onBlur,
					}}
				/>
				<div className="flex gap-1">
					<InfoRoundedIcon fontSize="small" className="!text-base" />
					<Typography fontWeight={400} fontSize={12}>
						Referrals and advice can be used for MDT (Multi Disciplinary Team)
						case discussion
					</Typography>
				</div>
			</div>
			{tags ? (
				<div className="container bg-white pb-4">
					<Link to="/dashboard/case/referrals/contact">
						<BasicButton
							variant="contained"
							color="secondary"
							className="!h-12 text-sm font-bold !shadow-none"
							fullWidth
						>
							Next
						</BasicButton>
					</Link>
				</div>
			) : null}
		</>
	);
}
